// extracted by mini-css-extract-plugin
export default {"trackingLinks":"TrackingLinks_trackingLinks__J5mEO","dispatch":"TrackingLinks_dispatch__IG-Eu","trackingLink":"TrackingLinks_trackingLink__T4NgI"};